<template>
  <div style="padding:20px;">
    <el-card>
      <h2>OPPO 批量复制定向包</h2>

      <el-form label-width="140px">
        <el-form-item label="Cookie">
          <el-input type="textarea" v-model="form.cookie" rows="3"/>
        </el-form-item>

        <el-form-item label="tk">
          <el-input v-model="form.tk"/>
        </el-form-item>

        <el-form-item label="源子账户ID">
          <el-input v-model="form.sourceOwnerId"/>
        </el-form-item>

        <el-form-item label="源定向包ID">
          <el-input v-model="form.sourceTargetId"/>
        </el-form-item>

        <el-form-item label="目标子账户ID（每行一个）">
          <el-input type="textarea" rows="5" v-model="form.targetOwnerIds"/>
        </el-form-item>

        <!-- ✅ 新增选项 -->
        <el-form-item label="创建后自动绑定广告组">
          <el-switch
            v-model="autoBindGroups"
            active-text="是"
            inactive-text="否"
          />
        </el-form-item>

        <el-button type="primary" @click="start">开始复制</el-button>
      </el-form>
    </el-card>

    <el-card style="margin-top:20px;">
      <h3>执行日志</h3>
      <el-table :data="logs" border size="mini">
        <el-table-column prop="time" label="时间" width="160"/>
        <el-table-column prop="ownerId" label="目标账户"/>
        <el-table-column prop="targetName" label="定向包名称"/>
        <el-table-column prop="targetId" label="定向包ID"/>
        <el-table-column prop="status" label="状态"/>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import XLSX from 'xlsx'

export default {
  data () {
    return {
      form: {
        cookie: '',
        tk: '',
        sourceOwnerId: '',
        sourceTargetId: '',
        targetOwnerIds: ''
      },
      sourceTarget: null,
      sourceAudienceName: null,
      logs: [],
      excelData: [],

      // ✅ 新增：是否自动绑定广告组
      autoBindGroups: false
    }
  },

  methods: {
    now () {
      return new Date().toLocaleString()
    },

    post (url, data) {
      return this.$axios.post(url, data)
    },

    start () {
      this.logs = []
      this.excelData = []

      this.post('https://control.zjwec.cn/api/oppohook/ownerLoginForward', {
        cookie: this.form.cookie,
        tk: this.form.tk,
        ownerId: this.form.sourceOwnerId
      }).then(() => this.loadSourceTarget())
    },

    loadSourceTarget () {
      this.post('https://control.zjwec.cn/api/oppohook/targetListForward', {
        queryType: 'target',
        idAndName: this.form.sourceTargetId,
        cookie: this.form.cookie,
        tk: this.form.tk,
        multiAccessId: this.form.sourceOwnerId
      }).then(res => {
        this.sourceTarget = res.data.data.items[0]
        const oppIds = this.sourceTarget.oppAudienceIds
        if (oppIds && oppIds.length > 0) {
          this.loadSourceAudience(oppIds[0])
        } else {
          this.batchCreate(null)
        }
      })
    },

    loadSourceAudience (id) {
      this.post('https://control.zjwec.cn/api/oppohook/targetListForward', {
        queryType: 'audience',
        idAndName: id,
        cookie: this.form.cookie,
        tk: this.form.tk,
        multiAccessId: this.form.sourceOwnerId
      }).then(res => {
        this.sourceAudienceName = res.data.data.items[0].targetName
        this.batchCreate(this.sourceAudienceName)
      })
    },

    batchCreate (audienceName) {
      var targets = this.form.targetOwnerIds.split('\n')
        .map(function (i) { return i.trim() })
        .filter(Boolean)

      var self = this

      var next = function (i) {
        if (i >= targets.length) {
          self.downloadExcel()
          return
        }

        var ownerId = targets[i]

        self.post('https://control.zjwec.cn/api/oppohook/ownerLoginForward', {
          cookie: self.form.cookie,
          tk: self.form.tk,
          ownerId: ownerId
        }).then(function () {
          if (audienceName) {
            self.findTargetAudience(ownerId, audienceName, function (audId) {
              self.create(ownerId, audId, function () {
                next(i + 1)
              })
            })
          } else {
            self.create(ownerId, null, function () {
              next(i + 1)
            })
          }
        })
      }

      next(0)
    },

    findTargetAudience (ownerId, name, cb) {
      this.post('https://control.zjwec.cn/api/oppohook/targetListForward', {
        queryType: 'audience',
        idAndName: name,
        cookie: this.form.cookie,
        tk: this.form.tk,
        multiAccessId: ownerId
      }).then(res => cb(res.data.data.items[0].targetId))
    },

    // ================== 重点修改方法 ==================
    create (ownerId, audienceId, cb) {
      var self = this

      var allowKeys = [
        'type','immutable','sex','age','ageNew','region','network','mobilePrice',
        'neverInstallAppList','notInstallAppList','installAppList','yesterdayInstalledApp',
        'installedNeverActiveAppList','preInstallAppList','unPreInstallAppList',
        'promoteAppNotInstalled','promoteAppInstall','unionAppIdRe','instantNotInstallList',
        'instantInstallList','appCatActive','appActive','appNotActive','appNotActiveDays',
        'appActiveDays','interestTags','interestTagsV2','tagsSystemRecommend','mobileModel',
        'flowAppCatActive','unionMediaTag','filterConvertedAd'
      ]

      var data = {}
      for (var i = 0; i < allowKeys.length; i++) {
        data[allowKeys[i]] = this.sourceTarget[allowKeys[i]]
      }

      var ts = Date.now()
      data.targetName = this.sourceTarget.targetName + '_' + ts
      data.targetDesc = ''
      data.cookie = this.form.cookie
      data.tk = this.form.tk
      data.targetOwnerId = ownerId
      if (audienceId) data.oppAudienceIds = audienceId

      this.post('https://control.zjwec.cn/api/oppohook/createTarget', data).then(function (res) {
        var r = res.data || {}
        var tid = r.data ? r.data.targetId : ''

        self.logs.push({
          time: self.now(),
          ownerId: ownerId,
          targetName: data.targetName,
          targetId: tid,
          status: r.code === 0 ? '成功' : r.msg
        })

        // 创建失败
        if (r.code !== 0 || !tid) {
          self.excelData.push({
            '目标账户ID': ownerId,
            '定向包名称': data.targetName,
            '创建定向包ID': '',
            '绑定成功广告组数': 0,
            '绑定失败广告组数': 0,
            '返回结果': JSON.stringify(r)
          })
          cb()
          return
        }

        // 未开启自动绑定
        if (!self.autoBindGroups) {
          self.excelData.push({
            '目标账户ID': ownerId,
            '定向包名称': data.targetName,
            '创建定向包ID': tid,
            '绑定成功广告组数': 0,
            '绑定失败广告组数': 0,
            '返回结果': '未开启自动绑定'
          })
          cb()
          return
        }

        // 查询广告组
        self.post('https://control.zjwec.cn/api/oppohook/adGroup/ids', {
          cookie: self.form.cookie,
          tk: self.form.tk,
          multiAccessId: ownerId
        }).then(function (res2) {
          var ids = res2.data || []

          if (!ids.length) {
            self.excelData.push({
              '目标账户ID': ownerId,
              '定向包名称': data.targetName,
              '创建定向包ID': tid,
              '绑定成功广告组数': 0,
              '绑定失败广告组数': 0,
              '返回结果': '无广告组'
            })
            cb()
            return
          }

          // 分批绑定
          var batches = []
          for (var j = 0; j < ids.length; j += 100) {
            batches.push(ids.slice(j, j + 100))
          }

          var index = 0
          var success = 0
          var fail = 0

          var bindNext = function () {
            if (index >= batches.length) {
              self.excelData.push({
                '目标账户ID': ownerId,
                '定向包名称': data.targetName,
                '创建定向包ID': tid,
                '绑定成功广告组数': success,
                '绑定失败广告组数': fail,
                '返回结果': '绑定完成'
              })
              cb()
              return
            }

            self.post('https://control.zjwec.cn/api/oppohook/adGroup/batchTarget', {
              groupIds: batches[index].join(','),
              targetId: tid,
              cookie: self.form.cookie,
              tk: self.form.tk,
              multiAccessId: ownerId
            }).then(function (res3) {
              var d = res3.data || {}
              success += (d.successIds || []).length
              fail += (d.failIds || []).length
              index++
              bindNext()
            }).catch(function () {
              fail += batches[index].length
              index++
              bindNext()
            })
          }

          bindNext()
        })
      })
    },

    downloadExcel () {
      var ws = XLSX.utils.json_to_sheet(this.excelData)
      var wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, '结果')
      XLSX.writeFile(wb, '创建结果.xlsx')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/oppo/drpkg.vue